import "./Pricing.module.css";
import EnterpriseHeader from "@/reusable_sections/Header";
import PricingHero from "./sections/PricingHero";
import TransparentSubscriptionPlans from "./sections/TransparentSubscriptionPlans";
import PlatformCapabilitiesCompared from "./sections/PlatformCapabilitiesCompared";
import WhiteLabelAddOn from "./sections/WhiteLabelAddOn";
import CapacityPacksExplained from "./sections/CapacityPacksExplained";
import ByoKeyClarityBox from "./sections/ByoKeyClarityBox";
import OverLimitPolicy from "./sections/OverLimitPolicy";
import PricingFaq from "./sections/PricingFaq";
import NetworkFooter from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <EnterpriseHeader />
      <PricingHero />
      <TransparentSubscriptionPlans />
      <PlatformCapabilitiesCompared />
      <WhiteLabelAddOn />
      <CapacityPacksExplained />
      <ByoKeyClarityBox />
      <OverLimitPolicy />
      <PricingFaq />
      <NetworkFooter />
    </div>;
}